import { Fingerprint } from 'app/pages/frames/helpers/fingerprint';
import { fingerprintHashSeed } from 'common/constants';

export const favicon = 'https://assets.conekta.com/website/Home/favicon.ico';
export enum PaymentMethodType {
  BankTransfer = 'BankTransfer',
  Card = 'Card',
  Cash = 'Cash',
  Bnpl = 'Bnpl',
}

export const DECIMAL_DIGITS_ALLOWED: number = 2;
export const DECIMAL_POINT_CHAR: string = '.';
export const ONE_DECIMAL_POINT: number = 1;
export const SEPARATOR: string = '';

export enum ThreeDsValues {
  enable = 'Enabled',
  dynamic = 'EnabledDynamic',
  not = 'NotValid',
  off = 'Off',
}

export const getHashFromString = (value: string, seed: number = fingerprintHashSeed): string =>
  Fingerprint.x64Hash128(value, seed);

export const awsS3Url = 'https://assets.conekta.com/cpanel/statics/assets';

export enum PAYMENT_STATUS {
  paid = 'paid',
  failed = 'failed',
}
export const logoUrl = `${awsS3Url}/img/conekta-logo-symbol.svg`;
